export default "__VITE_ASSET__BiVCKpPb__"